import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=6562e45a&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=ts"
export * from "./StepIndicator.vue?vue&type=script&lang=ts"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=6562e45a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562e45a",
  null
  
)

export default component.exports